import React, { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import Image from "../Image/Image";
import InsideHeader from "../InSideViewHeader/InSideViewHeader";
import Popup from "../popup";
import { appNavigateTo } from "../../../store/actions/navActions";
import { useDispatch, useSelector } from "react-redux";
import { parseContent, trackPages, getCardType } from "../../../shared/utility";
import store from "../../../store";
import { useAppContent } from "../../../shared/AppContent";
import { funcFetchMasterData, funcFetchCityData, funcFetchBankListData, getProductData } from "../../../store/actions/MasterDataActions";
const CommonView = ({
  children,
  userDetail,
  classes,
  goTo,
  handleEdit,
  closePopup,
  handleclosePopup,
  cardName,
}) => {
  const { closeJourneyContent } = useAppContent();
  const [exitPopup, setExitPopup] = useState(false);
  const valError = useSelector((state) => state.User.valError);
  const dispatch = useDispatch();
  const currentAppState = useSelector((state) => state.AppState);
  const loc = useLocation();
  const getFormAbandonmentTrackEvent = () => {
    const state = store.getState();
    const screenName = state.AppState.screenName;
    switch (screenName) {
      case "personalDetails":
        return "name_mobile_conf";
      case "otpview":
        return "otp_conf";
      case "city":
        return "city_conf";
      case "pan":
        return "pan_dob_conf";
      case "email":
        return "mmn_email_conf";;
      case "professional":
        return "occupation_conf";
      case "officeaddress":
        return "company_add_conf";
      case "resiaddress":
        return "resi_add_manual";
      case "digiConsent":
        if (state.ResiAdd.screenFlow === "digiDenyDemoAndManual")
          return "add_accept_digilocker";
        else
          return "onclick_digilocker";
      case "kycDetails":
        return "view_virtual_card";
      case "credit":
        return "account_credited";
      case "pennydrop":
      case "account":
      case "debit":
      case "penyFailure":
      case "penySuccess":
        return "penny_drop";
      case "telcoValidateOTP":
        return "telco_otp_screen";  
      case "GstOptionScreen" :
      case "EpfoValidateOTP" :
      case "incomeSurrogate" :
      case "accountAggregatorStatus":
        case "posStatus":
        return "income_surrogate";
      default:
        return screenName;
    }
  }
  const exitJourney = () => {
    trackPages("tracking_126", getFormAbandonmentTrackEvent());
    setExitPopup(false);
    handleclosePopup(false);
    dispatch({ type: 'RESET_APP' });
    if (currentAppState?.cardListDetails?.cardType) {
      const cardTypeData = {
        cardType: getCardType(currentAppState?.cardListDetails?.cardType,userDetail.cardType),
        cardChannelCode: userDetail.channelCode,
      };
      dispatch(funcFetchMasterData(cardTypeData));
      dispatch(funcFetchBankListData(cardTypeData));
      dispatch(funcFetchCityData(cardTypeData));
      dispatch(getProductData(cardTypeData));
    }
    dispatch(
      appNavigateTo(
        { goTo: "landingPage", from: loc.state?.goTo },
        "APP_NAVIGATE_TO"
      )
    );
  };
  const checkForHeader = () => {
    const path = goTo;
    return (
      path === "otpview" ||
      path === "city" ||
      path === "pan" ||
      path === "email"
    );
  };
  return (
    <>
      {valError &&
        valError.errorCode &&
        (goTo === "resiaddress" || goTo === "gender") ? null : (
        <div
          className={classes.CloseHelpButton}
          onClick={() => {
            setExitPopup(true);
          }}
        >
          <button className={classes.Close}>
            <Image
              className={classes.CloseImg}
              filename={"Group514"}
              ext="png"
              renditions={["2x"]}
              alt=""
            />
          </button>
        </div>
      )}
      {(exitPopup || closePopup) && (
        <Popup
          popupStyle={
            goTo !== "personalDetails" ? "exitPopupSubheader" : "exitPopupStyle"
          }
          content={
            <>
              <div>
                <h3 className={classes.popupHeader}>
                  {parseContent(closeJourneyContent?.heading, '{name}', userDetail && userDetail.firstName
                    ? userDetail.firstName
                    : "Customer")}
                </h3>
                {goTo !== "personalDetails" && (
                  <div className={classes.popupMiddleContent}>
                    {closeJourneyContent?.subheading}
                  </div>
                )}
              </div>
            </>
          }
          filename={"arrow_forward_black-1"}
          ext={"png"}
          renditions={["2x"]}
          handleClose={() => {
            setExitPopup(false);
            handleclosePopup();
          }}
          buttonLabel={closeJourneyContent?.continueButton}//"Continue to apply"
          exitApply={closeJourneyContent?.exitButton}//"Exit apply journey"
          exit={exitJourney}
        />
      )}
      {checkForHeader() ? (
        <div className={classes.PageContainer}>
          <div className={classes.ScrollCont}>
            <InsideHeader
              handleEdit={handleEdit}
              goTo={goTo}
              classes={classes}
              userDetail={userDetail}
            />
            <Fragment>{children}</Fragment>
          </div>
        </div>
      ) : (
        <div className={classes.PageContainer}>
          <div id="scrollId" className={classes.ScrollCont}>{children}</div>
        </div>
      )}
    </>
  );
};

export default CommonView;
